<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ (isEdit ? 'modals.project-report.title-edit' : 'modals.project-report.title-add') | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" type="button" (click)="cancel()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<form (ngSubmit)="save()">
  <div class="container my-4 project-report-form">
    <div class="drop-zone mb-1" [class.dragging]="dragging" [class.has-error]="fileError"
      (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)">
      @if (currentFileName) {
        <div class="selected-file">
          <mat-icon class="file-icon">{{ projectReportFileIcon(currentFileName) }}</mat-icon>
          <span class="file-name" [matTooltip]="currentFileName">{{ currentFileName }}</span>
          @if (file) {
            <button mat-icon-button type="button" (click)="clearFile()" [matTooltip]="'generic.remove' | translate">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
        <label class="replace-link">
          {{ (isEdit ? 'modals.project-report.replace-file' : 'modals.project-report.change-file') | translate }}
          <input type="file" hidden [accept]="acceptAttribute" (change)="onFileInput($event)">
        </label>
      } @else {
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="mb-1">{{ 'modals.project-report.drop-hint' | translate }}</p>
        <label class="choose-link">
          {{ 'modals.project-report.choose-file' | translate }}
          <input type="file" hidden [accept]="acceptAttribute" (change)="onFileInput($event)">
        </label>
        <small class="text-muted d-block mt-2">{{ 'modals.project-report.allowed-types' | translate: { types: acceptedExtensions.join(', '), size: 50 } }}</small>
      }
    </div>
    @if (fileError) {
      <div class="file-error mb-3">{{ fileError }}</div>
    }

    <mat-form-field appearance="outline" class="w-100 mt-3" subscriptSizing="dynamic">
      <mat-label>{{ 'modals.project-report.field-title' | translate }}</mat-label>
      <input matInput name="report_title" maxlength="255" [(ngModel)]="title">
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100 mt-3" subscriptSizing="dynamic">
      <mat-label>{{ 'modals.project-report.field-notes' | translate }}</mat-label>
      <textarea matInput rows="4" name="report_notes" maxlength="5000" [(ngModel)]="notes"></textarea>
    </mat-form-field>
  </div>

  <div class="buttons-container container mb-3 d-flex justify-content-center">
    <button mat-stroked-button class="text-dark-purple border-purple mr-2" type="button" (click)="cancel()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!canSave">
      @if (saving) {
        <mat-spinner diameter="18" class="d-inline-block mr-2"></mat-spinner>
      }
      {{ 'generic.buttons.save' | translate }}
    </button>
  </div>
</form>
